function executeInterchange() {
    // prettier-ignore
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    // eslint-disable-next-line
    window.Krux || ((window.Krux = function () { Krux.q.push(arguments); }).q = []);
    (() => {
        function retrieve(n) {
            const k = `${"kxalmamedia_"}${n}`;
            const ls = (() => {
                try {
                    return window.localStorage;
                }
                catch (e) {
                    return null;
                }
            })();
            if (ls) {
                return ls[k] || "";
            }
            if (navigator.cookieEnabled) {
                const m = document.cookie.match(`${k}=([^;]*)`);
                return (m && unescape(m[1])) || "";
            }
            return "";
        }
        window.Krux.user = retrieve("user");
        window.Krux.kuid = retrieve("kuid");
        window.Krux.segments = retrieve("segs") ? retrieve("segs").split(",") : [];
    })();
}
export default executeInterchange;
//# sourceMappingURL=interchange.js.map